(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/playscan-notifications/assets/javascripts/playscan-notifications.js') >= 0) return;  svs.modules.push('/components/components/playscan-notifications/assets/javascripts/playscan-notifications.js'); (function($, svs) {
  svs.components = svs.components || {};
  svs.components.playscan_notifications =
    svs.components.playscan_notifications || {};
  var logger = svs.core.log.getLogger('playscan-notifications');
  var playscanBadge = '.js-playscan-msg';
  var playscanBadgeClasses = 'animate animate-show badge badge-red badge-small';

  function showPlayscanBadge(numberOfMessages) {
    var msg = numberOfMessages.toString();
    if (numberOfMessages > 9) {
      msg = '9+';
    }
    $(playscanBadge)
      .removeClass(playscanBadgeClasses)
      .addClass(playscanBadgeClasses)
      .html(msg);
  }

  function hidePlayscanBadge() {
    $(playscanBadge)
      .removeClass(playscanBadgeClasses)
      .empty();
  }

  function checkPlayScanStatus() {
    var options = {};
    if (svs.core.detect.tenant('lb')) {
      options = {
        method: 'GET',
        path: '/player/notifications/playscan/count'
      };
      svs.core.jupiter.call(
        options,
        function(data) {
          if (data && data.playscan && data.playscan.unread >= 0) {
            var count = data.playscan.unread;
            logger.debug('Save to local storage');
            svs.components.Storage.browser.set('msgs', 'playscan', count, 30);
            handlePlayscanData(count);
          }
        },
        function(err) {
          hidePlayscanBadge();
          if (err && err.responseJSON) {
            logger.error(err.responseJSON);
          }
        }
      );
    } else {
      options = {
        method: 'GET',
        path: '/player/notifications/unreadPlayscanMsgs'
      };
      svs.core.jupiter.call(
        options,
        function(data) {
          if (
            data &&
            Array.isArray(data.notifications) &&
            data.notifications.length > 0
          ) {
            var count = data.notifications[0].value;
            logger.debug('Save to local storage');
            svs.components.Storage.browser.set('msgs', 'playscan', count, 30);
            handlePlayscanData(count);
          }
        },
        function(err) {
          hidePlayscanBadge();
          if (err && err.responseJSON) {
            logger.error(err.responseJSON);
          }
        }
      );
    }
  }

  function handlePlayscanData(count) {
    if (count === 0) {
      hidePlayscanBadge();
    } else if (count > 0) {
      showPlayscanBadge(count);
    } else {
      logger.error('Unknown unread playscan messages value: ', count);
    }
  }


  if (!svs.core.detect.feature('ft-playscan-toaster')) { 
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.components.Storage.browser.get('msgs', 'playscan', function(
        count,
        err
      ) {
        if (!err && count !== undefined) {
          logger.debug('Fetched from local storage');
          handlePlayscanData(count);
        } else {
          logger.debug('Fetch from api');
          checkPlayScanStatus();
        }
      });
    } else {
      logger.debug('Removed, not logged in');
      svs.components.Storage.browser.remove('msgs', 'playscan');
    }
    svs.components.playscan_notifications = {
      show: showPlayscanBadge,
      hide: hidePlayscanBadge,
      check: checkPlayScanStatus
    };
  }
})(jQuery, svs);

 })(window);